import React from "react";
import { PieChart, Pie, Cell, Legend } from "recharts";
import { SIGNOL_COLOURS } from "@signolteam/shared/colours";
import { useManagerContext } from "@src/context/managerContext";
import ManagerHooks from "@src/context/hooks/managerHooks";
import { AppUtils, SignolUtils } from "@src/utils";
import { DropDown, Loader, Tooltip } from "@src/components/atoms";
import PieChartLib from "@src/components/graphs/PieChart";
import { ManagersBehaviourChangeCard } from "@src/components/cards/manager";
import PerformanceDataCountsAndPieChartCard from "./PerformanceDataCountsAndPieChartCard";
import PerformanceFuelSavingsVsPreCard from "./PerformanceFuelSavingsVsPreCard";
import PerformanceSuccessRateVsPreCard from "./PerformanceSuccessRateVsPreCard";
import MonthlyDateDropDown from "../../../components/atoms/manager/MonthlyDateDropDown";
import { useDCContext } from "../../../context";

const TeamPicker = () => {
  const { profile, selectedTeam, setSelectedTeam } = useManagerContext();
  const dc = useDCContext();

  const customerCodeLower = profile.customer.customerCode.toLowerCase();
  const teams = profile.teams || [];

  const dropDownOptions = [
    {
      value: null,
      text: "All Teams",
    },
    ...teams.map((t) => ({
      value: t.id,
      text: t.alias || t.name,
    })),
  ];
  const shouldShowTooltip = dc.existsDynamicReplacements(
    `fuel_manager__tooltip__behaviour_performance__team_filter__${customerCodeLower}__tooltip`,
  );

  return (
    <div className="flex flex-row justify-start items-center px-5 py-2 gap-2">
      <div className="flex-1 lg:flex-none flex flex-row items-center gap-2">
        <span className="font-semibold">
          {dc.getDynamicReplacement(
            "fuel_manager__behaviour__team_filter_text",
          )}
        </span>
        <DropDown
          value={selectedTeam?.id ?? null}
          options={dropDownOptions}
          onChange={(newTeamId) => {
            const newTeam = teams.find((t) => t.id === newTeamId);
            setSelectedTeam(newTeam);
          }}
        />
      </div>
      {shouldShowTooltip && (
        <Tooltip
          content={[
            dc.getDynamicReplacement(
              `fuel_manager__tooltip__behaviour_performance__team_filter__${customerCodeLower}__tooltip`,
            ),
          ]}
          direction={SignolUtils.isMobile() ? "down-left" : "down-right"}
          absolute={false}
        />
      )}
    </div>
  );
};

export const teamPickerControls = {};
TeamPicker.propTypes = AppUtils.getPropTypeFromControls(teamPickerControls);
export default TeamPicker;
